/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListAgentsRequest,
  ListAgentsSecurity,
} from "../models/operations/listagents.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  AgentsQueryData,
  buildAgentsQuery,
  prefetchAgents,
  queryKeyAgents,
} from "./agents.core.js";
export {
  type AgentsQueryData,
  buildAgentsQuery,
  prefetchAgents,
  queryKeyAgents,
};

export type AgentsQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * list agents
 */
export function useAgents(
  request?: ListAgentsRequest | undefined,
  security?: ListAgentsSecurity | undefined,
  options?: QueryHookOptions<AgentsQueryData, AgentsQueryError>,
): UseQueryResult<AgentsQueryData, AgentsQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildAgentsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * list agents
 */
export function useAgentsSuspense(
  request?: ListAgentsRequest | undefined,
  security?: ListAgentsSecurity | undefined,
  options?: SuspenseQueryHookOptions<AgentsQueryData, AgentsQueryError>,
): UseSuspenseQueryResult<AgentsQueryData, AgentsQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildAgentsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setAgentsData(
  client: QueryClient,
  queryKeyBase: [parameters: { gramSession?: string | undefined }],
  data: AgentsQueryData,
): AgentsQueryData | undefined {
  const key = queryKeyAgents(...queryKeyBase);

  return client.setQueryData<AgentsQueryData>(key, data);
}

export function invalidateAgents(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "agents", "list", ...queryKeyBase],
  });
}

export function invalidateAllAgents(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "agents", "list"],
  });
}
